module.exports = __webpack_public_path__ + "img/podimo.c1cf4583.svg";